import { SettingsRoutes } from 'pages/settings/route/type'
import { NumbersRoutes } from 'pages/settings/pages/numbers/route/type'
import { AddNumbersRoutes } from 'pages/settings/pages/numbers/pages/AddNumber/route/type'
import { BuyNumberRoutes } from 'pages/settings/pages/numbers/pages/BuyNumber/route/type'
import { AddNumberFromAppRoutes } from 'pages/settings/pages/numbers/pages/AddNumberFromApp/route/type'
import { TextEnableLandlineRoutes } from 'pages/settings/pages/numbers/pages/TextEnableLandline/route/type'
import { ImportTwilioNumbersRoutes } from 'pages/settings/pages/numbers/pages/ImportTwilioNumbers/route/type'

const numbers = `${SettingsRoutes.root}/${NumbersRoutes.root}`

const addNumbers = `${numbers}/${AddNumbersRoutes.root}`

const buyNumbers = `${numbers}/${BuyNumberRoutes.root}`
const buyNumberSteps = `${buyNumbers}/${BuyNumberRoutes.steps}`
const buyNumberStepsRoot = `${buyNumberSteps}/${BuyNumberRoutes.chooseNumber}`

const addNumberFromApp = `${numbers}/${AddNumberFromAppRoutes.root}`
const addNumberFromAppSteps = `${addNumberFromApp}/${AddNumberFromAppRoutes.steps}`
const addNumberFromAppStepsRoot = `${addNumberFromAppSteps}/${AddNumberFromAppRoutes.selectAppAndNumbers}`

const textEnableLandline = `${numbers}/${TextEnableLandlineRoutes.root}`
const textEnableLandlineOld = TextEnableLandlineRoutes.rootOld
const textEnableLandlineSteps = `${textEnableLandline}/${TextEnableLandlineRoutes.steps}`
const textEnableLandlineStepsRoot = `${textEnableLandlineSteps}/${TextEnableLandlineRoutes.enterNumber}`

const importTwilioNumbers = `${numbers}/${ImportTwilioNumbersRoutes.root}`
const importTwilioNumbersEmpty = `${importTwilioNumbers}/${ImportTwilioNumbersRoutes.empty}`

export const NumbersPath = {
  root: numbers,
  addNumber: {
    root: addNumbers,
  },
  buyNumber: {
    root: buyNumbers,
    steps: buyNumberSteps,
    stepsRoot: buyNumberStepsRoot,
  },
  addNumberFromApp: {
    root: addNumberFromApp,
    steps: addNumberFromAppSteps,
    stepsRoot: addNumberFromAppStepsRoot,
  },
  textEnableLandline: {
    root: textEnableLandline,
    rootOld: textEnableLandlineOld,
    steps: textEnableLandlineSteps,
    stepsRoot: textEnableLandlineStepsRoot,
  },
  importTwilioNumbers: {
    root: importTwilioNumbers,
    empty: importTwilioNumbersEmpty,
  },
}
